import React from 'react';
import SamplePageContainer from '../../Componant/SamplePage/SimplePage';

const SamplePage = () => {
  return (
    <div className='page-body'>
      <SamplePageContainer />
    </div>
  );
};

export default SamplePage;
